
const digest = 'dedfda21427b84a29da674078e223d8683895303582f71f60e569e87b109a70d';
const classes = {"item":"_item_o6c55_1","name":"_name_o6c55_9"};
const css = `._item_o6c55_1 {
  padding: 10px;
  background-color: white;
  font-size: 14px;
  height: 100%;
  text-align: center;
}

._name_o6c55_9 {
  padding: 10px;
  background-color: white;
  font-size: 14px;
  font-weight: 600;
  height: 100%;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  